// extracted by mini-css-extract-plugin
module.exports = {"logos":"styles_logos__341bd","programme-logo":"styles_programme-logo__SEf4c","programme-slogan":"styles_programme-slogan__2ALYQ","eu-emble":"styles_eu-emble__3zIRZ"};